import { useLanguage } from "./LanguageProvider";
import { Globe } from "lucide-react";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../components/ui/select";

export default function LanguageSelector({ variant = "nav" }) {
  const { lang, switchLanguage, languages } = useLanguage();

  if (variant === "minimal") {
    return (
      <Select value={lang} onValueChange={switchLanguage}>
        <SelectTrigger className="w-auto gap-2 bg-transparent border-white/10 text-white/40 rounded-none h-8 text-xs px-2 hover:border-gold/20 hover:text-gold/60 transition-all" data-testid="language-selector">
          <Globe size={12} strokeWidth={1.5} />
          <SelectValue />
        </SelectTrigger>
        <SelectContent className="bg-[#0A0D0B] border-white/10 min-w-[140px]">
          {languages.map(l => (
            <SelectItem key={l.code} value={l.code} className="text-sm">{l.label}</SelectItem>
          ))}
        </SelectContent>
      </Select>
    );
  }

  return (
    <Select value={lang} onValueChange={switchLanguage}>
      <SelectTrigger className="w-auto gap-2 bg-transparent border-none text-white/30 rounded-none h-8 text-xs px-1 hover:text-gold/60 transition-all focus:ring-0" data-testid="language-selector">
        <Globe size={13} strokeWidth={1.5} />
        <span className="uppercase">{lang}</span>
      </SelectTrigger>
      <SelectContent className="bg-[#0A0D0B] border-white/10 min-w-[140px]">
        {languages.map(l => (
          <SelectItem key={l.code} value={l.code} className="text-sm">{l.label}</SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
